<template>
  <div>
    <h4 class="switch_instruction--heading">{{ heading }}</h4>
    <p class="switch_instruction--text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "FormFieldInstructions",
  props: {
    heading: {
      type: String,
    },
    text: {
      type: String,
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.switch_instruction {

  &--heading {
    margin-bottom: 6px;
    font-weight: bold;
  }

  &--text {
    margin-bottom: 8px;
    line-height: 1.2;
  }
}
</style>
